export const Counter = (event) => {
    return {
        current: 0,
        target: null,
        time: 1250,
        start: null,

        init () {
        },

        animate(amount) {
            this.start = this.current;
            this.target = amount;

            const interval = Math.max(this.time / (this.target - this.start), 5);
            const step = (this.target - this.start) /  (this.time / interval);

            const handle = setInterval(() => {
                if(this.current < this.target) 
                    this.current += step
                else {
                    clearInterval(handle);
                    this.current = this.target
                }   
            }, interval);
        },
    }
}
